module.exports = __webpack_public_path__ + "static/media/img_features_06.91fddb14.jpg";